import React from 'react'
import classNames from 'classnames'
import { DEFAULT_ACCENT } from '../../utils/constants'
import './style.scss'

const CheckBoxImage = ({ onClick, icon, iconText, color = DEFAULT_ACCENT, isChecked, onChange }) => {
  
  return (
    <div
      className={`viso-checkbox-image checkbox checkbox_${color}`}
      onClick={onClick}
    >
      <input type='checkbox' className='checkbox__input' checked={isChecked} onChange={onChange} />
      <div className={classNames('checkbox__image viso-checkbox-image__icon', !(iconText || icon) && 'checkbox__image viso-checkbox-image__icon--empty')}>
        {iconText || icon}
      </div>
    </div>
  )
}

export default CheckBoxImage